import { render, staticRenderFns } from "./PendingSwap.vue?vue&type=template&id=822a6b44&scoped=true"
import script from "./PendingSwap.vue?vue&type=script&lang=js"
export * from "./PendingSwap.vue?vue&type=script&lang=js"
import style0 from "./PendingSwap.vue?vue&type=style&index=0&id=822a6b44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822a6b44",
  null
  
)

export default component.exports